
import "./login.css";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

import { useState, useEffect, useTransition, useRef } from "react";

import { useForm } from "react-hook-form";

import { auth } from "../../services/firebaseConnection";
import { signInWithEmailAndPassword } from "firebase/auth";

/* navegação */
import { Link, useNavigate } from "react-router-dom";

/* funções auxiliares */
import { registerLog, showError, clearError } from "../../services/functions/functions.ts";



export default function Login() {

    const [error, setError] = useState("0");

    const { handleSubmit, register, getValues } = useForm();

    /* refs para tratamento de erros */
    const refEmail = useRef(null);
    const refLabelEmail = useRef(null);
    const refErrorEmail = useRef(null);

    const refSenha = useRef(null);
    const refLabelSenha = useRef(null);
    const refErrorSenha = useRef(null);
    /* -- */

    const navigate = useNavigate();

    const [isPending, startTransition] = useTransition();

    useEffect(() => { window.scrollTo(0, 0); }, []);


    async function login(data) {
        
        const v_email = (vemail) => { let validate = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; return validate.test(vemail); }
       
        let em = refEmail.current?.value || "";
        if(!v_email(em)) {
            showError(refEmail, refLabelEmail, refErrorEmail, "Esse email é inválido, verifique a digitação", setError, "email");
            return;
        }

        let sn = refSenha.current?.value || "";
        if(sn.length < 6) {
            showError(refSenha, refLabelSenha, refErrorSenha, "A senha deve ter entre 6 a 12 caracteres", setError, "senha");
            return;
        }

        startTransition( async() => {

        try {

            //faz a autenticação
            const userCredential = await signInWithEmailAndPassword(auth, em, sn);

            const uid = userCredential.user.uid;

            registerLog(uid, "/login/success");
            navigate("/panel");
           
        }
        catch(erro) {
            
            let er;

            if(erro.code === "auth/invalid-credential") {
                er = "Email e/ou senha não estão corretos, verifique as informações";
            } else {
                er = erro;
            }

            registerLog(-1, "/login/fail=" + em);
            showError(refSenha, refLabelSenha, refErrorSenha, er, setError, "senha");

        }
        })

    }



    return(

        <div className="context">

            <Header access={0}></Header>

            <div className="content">
                <div className="ft_topico">Acesso a nossa plataforma</div>
                <div className="ft_descricao">Ao acessar a plataforma você poderá configurar todos os parâmetros do seu agente.<br />Personalize ele conforme suas preferências e terá seu maior aliado para auxiliá-lo no atendimento a seus clientes.</div>
                <div className="space"></div>
                <span className="login_texto_destaque">Ainda não tem cadastro?</span>
                <div className="ft_descricao">Faça seu cadastro com pouquíssimas informações</div>
                <div className="login_space"></div>
                <Link to="/register" className="login_register" style={{textAlign: "center"}}>QUERO ME CADASTRAR</Link>
                <div className="space"></div>
                <div className="ft_descricao">Já é cadastrado?<br />faça seu login abaixo:</div>
                <div className="login_space"></div>

                <div className="border_form login_border_form">
                    <form className="form" onSubmit={handleSubmit(login)}>
                        <span className="title_form">Login na plataforma</span>
                        <span className="subtitle_form">Entre com seu email e a senha.</span>
                        
                        <span ref={refErrorEmail} className="error_form"></span>
                        <label for="inp" className="inp" ref={refLabelEmail}>
                        <input type="text" placeholder="&nbsp;" maxLength={40} {...register("email")} ref={(el) => {refEmail.current = el; register("email").ref(el);}} onClick={() => clearError(refEmail, refLabelEmail, refErrorEmail, error, setError)} onChange={() => clearError(refEmail, refLabelEmail, refErrorEmail, error, setError)} onKeyDown={(e) => {if (e.key === "Enter") {e.preventDefault(); handleSubmit(login)();}}}></input>
                        <span className="label">Seu Email</span>
                        <span className="focus-bg"></span>
                        </label>
                        <span className="space_form"></span>

                        <span ref={refErrorSenha} className="error_form"></span>
                        <label for="inp" className="inp" ref={refLabelSenha}>
                        <input type="password" placeholder="&nbsp;" maxLength={12} {...register("senha")} ref={(el) => {refSenha.current = el; register("senha").ref(el);}} onClick={() => clearError(refSenha, refLabelSenha, refErrorSenha, error, setError)} onChange={() => clearError(refSenha, refLabelSenha, refErrorSenha, error, setError)} onKeyDown={(e) => {if (e.key === "Enter") {e.preventDefault(); handleSubmit(login)();}}}></input>
                        <span className="label">Sua Senha</span>
                        <span className="focus-bg"></span>
                        </label>
                        <span className="space_form"></span>

                        <button type="submit" name="bt1" className={ isPending ? "button_disabled_form" : "button_form" } disabled={ isPending ? true : false }>{ isPending ? "AGUARDE ..." : "ACESSAR" }</button>
                    </form>
                </div>

                <div className="space"></div>
                <div className="login_forgot_box">
                    <span className="login_forgot_text">Esqueceu a senha?&nbsp;</span>
                    <Link to="/reset" className="login_forgot_password">Clique Aqui</Link>
                </div>
                <div className="space"></div>
                <div className="space"></div>
                <div className="space"></div>

            </div>

            <Footer access={0}></Footer>

        </div>

    )
}